import { render } from "./TemplateOneTimeCode.vue?vue&type=template&id=04de676d&scoped=true"
import script from "./TemplateOneTimeCode.vue?vue&type=script&lang=js"
export * from "./TemplateOneTimeCode.vue?vue&type=script&lang=js"

import "./TemplateOneTimeCode.vue?vue&type=style&index=0&id=04de676d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04de676d"

export default script